import axios from 'axios'

export const Host = "../api/sign";
export const SourceHost = window.location.protocol + "//" + window.location.host + "/";

export const Login = (id, pwd) => {
  return axios.get(`${Host}/user/login/${id}/${pwd}`).then(res => res.data);
};

export const GetCompany = (parm) => {
  return axios.post(`${Host}/cmp/get`, parm).then(res => res.data);
};

export const AddCompany = (parm) => {
  return axios.post(`${Host}/cmp/add`, parm).then(res => res.data);
};

export const AddUser = (parms) => {
  return axios.post(`${Host}/user/add`, parms).then(res => res.data);
};

export const GetUser = (parm, companyid) => {
  return axios.post(`${Host}/user/get/${companyid}`, parm).then(res => res.data);
};

export const GetLogs = (parm, companyid) => {
  return axios.post(`${Host}/log/get/${companyid}`, parm).then(res => res.data);
};

export const AddQutype = (parm) => {
  return axios.post(`${Host}/qtype/add`, parm).then(res => res.data);
};

export const GetQutype = (parm, companyid) => {
  return axios.post(`${Host}/qtype/get/${companyid}`, parm).then(res => res.data);
};

export const GetPageAgent = (parm, companyid) => {
  return axios.post(`${Host}/agent/getpage/${companyid}`, parm).then(res => res.data);
};

export const GetAgent = (parm, companyid) => {
  return axios.post(`${Host}/agent/get/${companyid}`, parm).then(res => res.data);
};

export const AddAgent = (parm) => {
  return axios.post(`${Host}/agent/add`, parm).then(res => res.data);
};

export const GetSign = (parm, companyid) => {
  return axios.post(`${Host}/sign/get/${companyid}`, parm).then(res => res.data);
};

export const GetSignById = (id) => {
  return axios.get(`${Host}/sign/query/${id}`).then(res => res.data);
};

export const AddSign = (parm) => {
  return axios.post(`${Host}/sign/add`, parm).then(res => res.data);
};

export const ChangePwd = (parm) => {
  return axios.post(`${Host}/user/cpwd`, parm).then(res => res.data);
};

export const UpdateSys = () => {
  return axios.get(`${Host}/sys/update`).then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/api/api.js